// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@bg/XDL/types";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

export default {
    defaultProps: {
        color: "primary",
        border: "rounded",
        typographyProps: {},
        sizeVariant: "default",
        errorProps: {},
        css: css``,
        cssOverrides: {
            formInputWrapper: css`
                input,
                select,
                textarea {
                    &:disabled {
                        opacity: 0.5;
                        background: ${getColor("common.ui4")} !important;
                        color: inherit !important;
                    }
                }
            `,
            descriptionWrapper: css`
                margin-top: 5px !important;

                * {
                    font-size: 13px;
                    font-weight: 400;
                    line-height: 15px;
                }

                display: flex;
                flex-direction: column;
            `,
            formField: css`
                label[disabled] {
                    opacity: 0.5;
                }
            `,
        },
    },
} as xBaseTheme["fieldSet"];
